// 산업용 전문가 스타일 테마
// 다크 네이비 + 오렌지 강조색 + 메탈릭 그레이

export const industrialTheme = {
  // 색상 팔레트
  colors: {
    // 메인 색상 (다크 네이비)
    primary: {
      main: '#1a2332',      // 다크 네이비
      light: '#2c3e50',     // 밝은 네이비
      dark: '#0d1117',      // 더 어두운 네이비
      gradient: 'linear-gradient(135deg, #1a2332 0%, #2c3e50 100%)',
    },

    // 강조 색상 (오렌지)
    accent: {
      main: '#ff6b35',      // 선명한 오렌지
      light: '#ff8c61',     // 밝은 오렌지
      dark: '#e55a2b',      // 어두운 오렌지
      glow: 'rgba(255, 107, 53, 0.3)', // 글로우 효과
    },

    // 제품 카테고리별 색상
    products: {
      plc: '#4a90e2',       // 블루 (PLC)
      motion: '#ff6b35',    // 오렌지 (Motion)
      servo: '#9b59b6',     // 퍼플 (Servo)
      inverter: '#00897B',  // 티얼 (Inverter)
      all: '#2ecc71',       // 그린 (통합검색)
    },

    // 중성 색상 (메탈릭 그레이)
    neutral: {
      white: '#ffffff',
      lightGray: '#ecf0f1',
      gray: '#95a5a6',
      darkGray: '#34495e',
      border: '#bdc3c7',
      shadow: 'rgba(0, 0, 0, 0.1)',
    },

    // 상태 색상
    status: {
      success: '#27ae60',
      warning: '#f39c12',
      error: '#e74c3c',
      info: '#3498db',
    },
  },

  // 그림자 효과
  shadows: {
    card: '0 4px 12px rgba(0, 0, 0, 0.08)',
    cardHover: '0 8px 24px rgba(0, 0, 0, 0.15)',
    glow: '0 0 20px rgba(255, 107, 53, 0.3)',
    glowBlue: '0 0 20px rgba(74, 144, 226, 0.3)',
    glowPurple: '0 0 20px rgba(155, 89, 182, 0.3)',
    glowTeal: '0 0 20px rgba(0, 137, 123, 0.3)',
  },

  // 애니메이션
  transitions: {
    fast: 'all 0.2s ease',
    normal: 'all 0.3s ease',
    slow: 'all 0.5s ease',
  },

  // 타이포그래피
  typography: {
    fontFamily: "'Noto Sans KR', 'Roboto', sans-serif",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
};

// Material-UI 테마 오버라이드
export const muiThemeOverrides = {
  palette: {
    primary: {
      main: industrialTheme.colors.primary.main,
      light: industrialTheme.colors.primary.light,
      dark: industrialTheme.colors.primary.dark,
    },
    secondary: {
      main: industrialTheme.colors.accent.main,
      light: industrialTheme.colors.accent.light,
      dark: industrialTheme.colors.accent.dark,
    },
    background: {
      default: '#f5f7fa',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: industrialTheme.typography.fontFamily,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
          padding: '10px 24px',
          transition: industrialTheme.transitions.normal,
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: industrialTheme.shadows.cardHover,
          },
        },
        contained: {
          boxShadow: industrialTheme.shadows.card,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: industrialTheme.shadows.card,
          transition: industrialTheme.transitions.normal,
          border: `1px solid ${industrialTheme.colors.neutral.border}`,
          '&:hover': {
            boxShadow: industrialTheme.shadows.cardHover,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          fontWeight: 500,
        },
      },
    },
  },
};
